var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"culture"},_vm._l((_vm.cultureList),function(item,i){return _c('div',{key:i,staticClass:"culture_item"},[_c('img',{attrs:{"src":require("../assets/images/icon_about_value.png"),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"cu_name"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.tip))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f431d802","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/culture.vue
// module id = null
// module chunks = 